export default __webpack_public_path__ + "static/media/Open-News-LandingPage.a2f5b5d3.png";